import { SettingDrawerState } from '@ant-design/pro-layout';
import * as Mamba from '@mamba/clients';
import localforage from 'localforage';
import lodash from 'lodash';
import { IHydrateResult } from 'mobx-persist';
import React from 'react';
import { UserAgent } from './userAgent';
// 持久化访问器
const LocalForage = localforage.createInstance({
  // driver: localforage.LOCALSTORAGE, // Forc
  name: process.env.StorageKey,
  storeName: process.env.StorageKey,
});
Mamba.BasesOptions.resetConfig({
  // storagePrefix: process.env.StorageKey,
  createStorage: lodash.constant({
    clear: LocalForage.clear,
    setItem: LocalForage.setItem,
    removeItem: LocalForage.removeItem,
    getItem: LocalForage.getItem,
  }),
});
// const Hydrate = Mamba.BasesOptions.createHydrate();
declare type AppSettings = SettingDrawerState & {
  /** 表单弹框类型 */
  formType: 'Modal' | 'Drawer';
};
export class AppConfig extends Mamba.ClientsEnv {
  static LocalForage: LocalForage;
  // @persist('object')
  // @observable
  AppSettings: AppSettings = {
    title: '智能销售工作台',
    contentWidth: 'Fluid',
    fixSiderbar: true,
    fixedHeader: true,
    formType: 'Drawer',
    headerHeight: 48,
    language: 'zh',
    layout: 'top',
    navTheme: 'light',
    // primaryColor: "#1890ff",
    splitMenus: false,
  };
  /**
   * 判断是否被 嵌套成子页面
   * @readonly
   * @memberof AppConfig
   */
  get ChildrenPage() {
    return window.self !== window.top || this.MICRO;
  }
  /**
   * __MICRO_APP_ENVIRONMENT__
   * @memberof AppConfig
   */
  readonly MICRO = window.__MICRO_APP_ENVIRONMENT__;

  /** 旧版登陆地址 */
  get oldLoginUrl() {
    return `${this.pcDomain}/portal/web/bpportal/bpplogin`;
  }
  /** 经销商账号激活 */
  get dealerActivation() {
    return `/dlxweb/#/inviteCodeRegister/inviteCodeRegister`;
  }
  /** 直签新代理注册 */
  get proxyRegister() {
    return `/user/#/register`;
  }
  /** 微信授权h5页面 */
  get wechatAuth() {
    return `${process.env.Target}/accountm/function/wechatlogin/`;
  }
  /** vconsole */
  readonly vconsole = this.release ? '' : 'vconsole';
  // @computed
  // get LayoutSettings(): SettingDrawerState {
  //     return lodash.omit(this.AppSettings, ['formType'])
  // }
  /**
   * 设置统一样式前缀。注意：需要配合 less 变量 @ant-prefix 使用
   * @doc https://ant.design/components/config-provider-cn/
   * @memberof AppConfig
   */
  readonly prefixCls = process.env.prefixCls || 'workbench';
  /**
   * 环境设备信息
   * @memberof AppConfig
   */
  readonly userAgent = new UserAgent();
  /**
   * 更改配置
   * @param config
   */
  // @action.bound
  // onChangeAppSettings(AppSettings: Partial<AppSettings>) {
  //     const AppSettingsJS = toJS(this.AppSettings)
  //     if (lodash.isEqual(lodash.pick(AppSettingsJS, lodash.keys(AppSettings)), AppSettings)) {
  //         return
  //     }
  //     this.AppSettings = lodash.assign(AppSettingsJS, AppSettings)
  //     this.onChangeLanguage()
  //     React.$Mamba.Log.warning('AppConfig ~ onChangeConfig', AppSettingsJS, this)
  // }
  /**
   * 更改语言
   * @param config
   */
  // onChangeLanguage() {
  //     moment.locale(lodash.get({ zh: 'zh-cn' }, this.AppSettings.language, this.AppSettings.language))
  //     React.$i18n.changeLanguage(this.AppSettings.language)
  // }
  /**
   * 检查版本信息
   */
  async onInspectVersion() {
    const { LocalForage } = AppConfig;
    if (LocalForage) {
      const versionKey = this.createStorageKey('version');
      const versionVal = lodash.join([this.version, this.timestamp], '-');
      const version = await this.localforage.getItem<string>(versionKey);
      // 清理 版本 不统一缓存
      if (version && !lodash.eq(version, versionVal)) {
        this.onClear();
        // this.onRemoveAllCookie();
        return;
      }
    }
    // await this.localforage.setItem(versionKey, versionVal);
  }

  onRemoveAllCookie() {
    // const domian = ['localhost', '127.0.0.1'].includes(window.location.hostname)
    //   ? window.location.hostname
    //   : '.lenovo.com';
    // ['localhost', '127.0.0.1', '.lenovo.com', '.lenovo.com.cn'].map(
    //   (domain) => {
    //     Cookies.remove('usertokenUrl', { domain });
    //     Cookies.remove('usernameUrl', { domain });
    //     Cookies.remove('userName', { domain });
    //     Cookies.remove('BPPORTAL_TOKEN', { domain });
    //   },
    // );
  }
  /**
   * 清理缓存
   * @memberof ClientsEnv
   */
  async onClear() {
    const { LocalForage } = AppConfig;
    if (LocalForage) {
      const versionKey = this.createStorageKey('version');
      const versionVal = lodash.join([this.version, this.timestamp], '-');
      await LocalForage.clear();
      await LocalForage.setItem(versionKey, versionVal);
      return true;
    }
  }
}
export const $AppConfig = new AppConfig();
if ($AppConfig.MICRO) {
  //小智嵌套注册页面需要写入信息
  Mamba.AuthOptions.writeCheck = function () {
    console.log('允许微前端存储用户信息');
  };
}
$AppConfig.onInspectVersion();
lodash.set(React, 'AppConfig', $AppConfig);
// Hydrate($AppConfig.createStorageKey('app'), $AppConfig).then(() => {
//     $AppConfig.onInspectVersion()
//     // $AppConfig.onChangeLanguage()
// })
Object.defineProperty(React.Component.prototype, 'AppConfig', {
  get: lodash.constant($AppConfig),
});
declare module 'react' {
  /**
   * 全局设置
   */
  const AppConfig: AppConfig;
  /**
   * mobx-persist
   */
  const Hydrate: <T extends Object>(
    key: string,
    store: T,
    initialState?: any,
  ) => IHydrateResult<T>;
  interface Component {
    /** 全局设置 */
    readonly AppConfig: AppConfig;
  }
}
